<app-modal
  *ngIf="data as modalData"
  [title]="modalTitle"
  [size]="'xl'"
  [confirmLabel]="selectedEntry() ? 'Zapisz zmiany' : 'Dodaj wpis'"
  [cancelLabel]="'Zamknij'"
  [showCancel]="true"
  [showConfirm]="true"
  [isConfirmDisabled]="!canSaveCurrentSelection()"
  [onConfirmAction]="onSave.bind(this)"
>
  <div class="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
    <section class="space-y-4">
      <div class="rounded-2xl border border-[var(--app-border)] bg-[var(--app-surface-solid)] p-4">
        <div class="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p class="text-xs uppercase tracking-wide text-[var(--app-text-muted)]">Dzień</p>
            <p class="text-lg font-semibold text-[var(--app-text)]">
              {{ (modalData.dateIso + 'T00:00:00') | date: 'dd.MM.yyyy' }}
            </p>
            <p class="text-sm text-[var(--app-text-muted)]">
              {{ displayWorkItem || 'Bez przypisanego work itemu' }}
            </p>
          </div>

          <div class="flex flex-wrap items-center gap-2">
            <p-badge [value]="dayEntries().length + ' wpisów'" severity="info"></p-badge>
            <p-badge
              *ngIf="dayTotalEarnings() > 0"
              [value]="'Wynagrodzenie ' + formatMoney(dayTotalEarnings())"
              severity="success"
            ></p-badge>
            <p-badge
              *ngIf="selectedEntry()?.editableByCurrentUser === false"
              value="Tylko odczyt"
              severity="secondary"
            ></p-badge>
          </div>
        </div>
      </div>

      <form [formGroup]="timeEntryForm" class="space-y-4">
        <div class="rounded-2xl border border-[var(--app-border)] bg-[var(--app-surface-solid)] p-4">
          <div class="flex items-center justify-between gap-3">
            <div>
              <p class="text-sm font-semibold text-[var(--app-text)]">
                {{ selectedEntry() ? 'Edycja wpisu' : 'Nowy wpis' }}
              </p>
              <p class="text-xs text-[var(--app-text-muted)]">
                Wpisy mogą być tworzone wiele razy dla tego samego dnia.
              </p>
            </div>

            <p-button
              label="Nowy wpis"
              severity="secondary"
              outlined
              (onClick)="startNewEntry()"
            ></p-button>
          </div>

          <p-divider />

          <div class="space-y-4">
            <div *ngIf="!selectedEntry()" class="flex flex-col gap-2">
              <label for="workItemId" class="text-sm font-medium text-[var(--app-text)]">
                Work item
              </label>
              <ng-container *ngIf="workItemOptions().length > 0; else noWorkItemsState">
                <p-select
                  inputId="workItemId"
                  formControlName="workItemId"
                  [options]="workItemOptions()"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Wybierz work item"
                  appendTo="body"
                  styleClass="w-full"
                >
                  <ng-template let-item pTemplate="item">
                    <div class="flex flex-col">
                      <span>{{ item.name || 'Bez nazwy' }}</span>
                      <small class="text-[var(--app-text-muted)]">
                        {{ item.clientName || 'Bez klienta' }}
                      </small>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="selectedItem">
                    <span>{{ item.name || 'Bez nazwy' }}</span>
                  </ng-template>
                </p-select>
              </ng-container>
              <ng-template #noWorkItemsState>
                <div class="rounded-xl border border-dashed border-[var(--app-border)] bg-[var(--app-surface)] p-3 text-sm text-[var(--app-text-muted)]">
                  Nie masz jeszcze dostępnych work itemów do wyboru.
                  Jeśli właśnie utworzyłeś work item, upewnij się, że jesteś do niego dodany jako członek.
                </div>
              </ng-template>
            </div>

            <div class="flex flex-col gap-2">
              <label for="dateIso" class="text-sm font-medium text-[var(--app-text)]">
                Dzień wpisu
              </label>
              <input
                id="dateIso"
                type="date"
                pInputText
                formControlName="dateIso"
                class="w-full"
              />
              <small class="text-[var(--app-text-muted)]">
                Możesz przenieść wpis na inny dzień bez zmiany godziny.
              </small>
            </div>

            <div class="flex flex-col gap-2">
              <label for="start" class="text-sm font-medium text-[var(--app-text)]">Start</label>
              <input
                id="start"
                pInputText
                formControlName="start"
                placeholder="08:00"
                inputmode="numeric"
                class="w-full"
                (click)="onTimeClick('start', $event)"
                (blur)="onChangeTimeEntry('start')"
              />
              <small class="text-[var(--app-text-muted)]">Wpisz godzinę w formacie HH:mm</small>
            </div>

            <div class="flex items-center justify-between gap-4 rounded-xl border border-[var(--app-border)] bg-[var(--app-surface)] p-3">
              <div class="flex flex-col gap-1">
                <p class="text-sm font-medium text-[var(--app-text)]">Podaj czas trwania</p>
                <p class="text-xs text-[var(--app-text-muted)]">
                  Wyłącz, jeśli chcesz podać godzinę zakończenia i wyliczyć czas.
                </p>
              </div>
              <p-toggleswitch
                [(ngModel)]="useDurationMode"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onModeChange($event)"
              />
            </div>

            <ng-container *ngIf="useDurationMode; else endMode">
              <div class="grid gap-4 sm:grid-cols-2">
                <div class="flex flex-col gap-2">
                  <label for="duration" class="text-sm font-medium text-[var(--app-text)]">
                    Czas trwania
                  </label>
                  <p-inputNumber
                    inputId="duration"
                    formControlName="duration"
                    [min]="1"
                    [step]="15"
                    [useGrouping]="false"
                    [suffix]="' min'"
                    styleClass="w-full"
                    (onInput)="onDurationInput()"
                  ></p-inputNumber>
                </div>

                <div class="flex flex-col gap-2">
                  <label class="text-sm font-medium text-[var(--app-text)]">Koniec</label>
                  <input
                    pInputText
                    [value]="timeEntryForm.controls.end.value"
                    readonly
                    class="w-full bg-[var(--app-surface)]"
                  />
                  <small class="text-[var(--app-text-muted)]">
                    Wyliczony koniec pracy
                  </small>
                </div>
              </div>
            </ng-container>

            <ng-template #endMode>
              <div class="grid gap-4 sm:grid-cols-2">
                <div class="flex flex-col gap-2">
                  <label for="end" class="text-sm font-medium text-[var(--app-text)]">Koniec</label>
                  <input
                    id="end"
                    pInputText
                    formControlName="end"
                    placeholder="17:00"
                    inputmode="numeric"
                    class="w-full"
                    (click)="onTimeClick('end', $event)"
                    (blur)="onChangeTimeEntry('end')"
                  />
                  <small class="text-[var(--app-text-muted)]">
                    Wpisz godzinę w formacie HH:mm
                  </small>
                </div>

                <div class="flex flex-col gap-2">
                  <label class="text-sm font-medium text-[var(--app-text)]">Czas trwania</label>
                  <input
                    pInputText
                    [value]="formatDuration(timeEntryForm.controls.duration.value)"
                    readonly
                    class="w-full bg-[var(--app-surface)]"
                  />
                  <small class="text-[var(--app-text-muted)]">
                    Wyliczony czas pracy
                  </small>
                </div>
              </div>
            </ng-template>

            <div *ngIf="isThresholdBillingMode()" class="flex flex-col gap-2">
              <label for="revenueAmount" class="text-sm font-medium text-[var(--app-text)]">
                Kwota przychodu
              </label>
              <p-inputNumber
                inputId="revenueAmount"
                formControlName="revenueAmount"
                mode="currency"
                currency="PLN"
                locale="pl-PL"
                [min]="0"
                [step]="0.01"
                styleClass="w-full"
                placeholder="0,00 zł"
              ></p-inputNumber>
              <small class="text-[var(--app-text-muted)]">
                Dla rozliczenia progowego wpisz kwotę przychodu z danego wpisu.
              </small>
            </div>

            <div
              *ngIf="selectedEntry() && resolveEntryEarnings(selectedEntry()!) != null"
              class="rounded-xl border border-[var(--app-border)] bg-[var(--app-surface)] p-3"
            >
              <div class="flex items-center justify-between gap-3">
                <span class="text-sm font-medium text-[var(--app-text)]">
                  Wynagrodzenie użytkownika
                </span>
                <span class="text-base font-semibold text-[var(--app-text)]">
                  {{ formatMoney(resolveEntryEarnings(selectedEntry()!)) }}
                </span>
              </div>
            </div>
          </div>

          <div class="mt-4 flex items-center justify-between gap-4">
            <div class="flex flex-col gap-1">
              <p class="text-sm font-medium text-[var(--app-text)]">Płatny</p>
              <p class="text-xs text-[var(--app-text-muted)]">Wpis będzie uwzględniony w rozliczeniu.</p>
            </div>
            <p-toggleswitch formControlName="billable" />
          </div>

          <div class="mt-4 flex flex-col gap-2">
            <label for="description" class="text-sm font-medium text-[var(--app-text)]">Opis</label>
            <textarea
              id="description"
              pTextarea
              rows="4"
              maxlength="300"
              formControlName="description"
              placeholder="Nad czym dziś pracowałeś?"
              class="w-full"
            ></textarea>
          </div>

          <div
            *ngIf="selectedEntry()?.createdByUserName || selectedEntry()?.createdDate"
            class="mt-4 rounded-xl border border-dashed border-[var(--app-border)] bg-[var(--app-surface)] p-3 text-sm text-[var(--app-text-muted)]"
          >
            <div class="flex flex-wrap items-center gap-2">
              <span class="font-medium text-[var(--app-text)]">Utworzono przez:</span>
              <span>{{ selectedEntry()?.createdByUserName || 'nieznany' }}</span>
              <span *ngIf="selectedEntry()?.createdDate">
                · {{ selectedEntry()?.createdDate | date: 'dd.MM.yyyy, HH:mm' }}
              </span>
            </div>
          </div>

          <div
            *ngIf="selectedEntry() && selectedEntry()?.editableByCurrentUser === false"
            class="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-100"
          >
            Ten wpis został dodany przez właściciela i jest tylko do odczytu.
          </div>

          <div *ngIf="selectedEntry()?.editableByCurrentUser !== false" class="mt-4 flex gap-3">
            <p-button
              *ngIf="selectedEntry()"
              label="Usuń wpis"
              severity="danger"
              outlined
              [disabled]="saving()"
              (onClick)="onDeleteSelectedEntry()"
            ></p-button>
          </div>
        </div>
      </form>
    </section>

    <section class="space-y-4">
      <div class="rounded-2xl border border-[var(--app-border)] bg-[var(--app-surface-solid)] p-4">
        <div class="flex items-center justify-between gap-3">
          <div>
            <p class="text-sm font-semibold text-[var(--app-text)]">Wpisy z dnia</p>
            <p class="text-xs text-[var(--app-text-muted)]">
              Kliknij wpis, aby go podejrzeć lub edytować.
            </p>
          </div>
          <p-badge [value]="formatDuration(dayTotalDuration())" severity="success"></p-badge>
        </div>

        <p-divider />

        <div *ngIf="loadingEntries()" class="py-10 text-center text-[var(--app-text-muted)]">
          Ładowanie wpisów dnia...
        </div>

        <div *ngIf="!loadingEntries() && dayEntries().length === 0" class="py-10 text-center">
          <i class="pi pi-calendar-times text-4xl text-[var(--app-text-muted)]"></i>
          <p class="mt-3 text-sm text-[var(--app-text-muted)]">
            Brak wpisów dla tego dnia. Możesz dodać pierwszy wpis po lewej stronie.
          </p>
        </div>
        <div *ngIf="!loadingEntries() && dayEntries().length > 0" class="space-y-5">
          <section *ngIf="previousDayEntries().length > 0" class="space-y-3">
            <div class="flex items-center gap-2">
              <p class="text-xs font-semibold uppercase tracking-wide text-[var(--app-text-muted)]">
                Wpisy rozpoczęte wcześniej
              </p>
              <p-badge value="Z poprzedniego dnia" severity="warn"></p-badge>
            </div>

            <button
              *ngFor="let entry of previousDayEntries(); trackBy: trackByEntryId"
              type="button"
              class="w-full rounded-xl border p-4 text-left transition hover:border-[var(--app-primary)] hover:bg-[var(--app-surface)]"
              [style.border-color]="isSelectedEntry(entry) ? 'var(--app-primary)' : 'var(--app-border)'"
              [style.background-color]="isSelectedEntry(entry) ? 'color-mix(in srgb, var(--app-primary) 6%, transparent)' : 'var(--app-surface-solid)'"
              (click)="selectEntry(entry)"
            >
              <div class="flex items-start justify-between gap-3">
                <div class="min-w-0">
                  <p class="font-semibold text-[var(--app-text)] truncate">
                    {{ entry.workItemName || 'Bez nazwy' }}
                  </p>
                  <p class="text-xs text-[var(--app-text-muted)] truncate">
                    {{ entry.clientName || 'Bez klienta' }}
                  </p>
                </div>

              <div class="text-right">
                <p class="text-sm font-semibold text-[var(--app-text)]">
                  {{ entry.start | date: 'HH:mm' }} - {{ entry.end | date: 'HH:mm' }}
                </p>
                <p class="text-xs text-[var(--app-text-muted)]">
                  {{ formatDuration(entry.duration) }}
                </p>
                <ng-container *ngIf="resolveEntryEarnings(entry) != null">
                  <p class="mt-2 text-[10px] uppercase tracking-wide text-[var(--app-text-muted)]">
                    Wynagrodzenie
                  </p>
                  <p class="text-sm font-semibold text-[var(--app-primary)]">
                    {{ formatMoney(resolveEntryEarnings(entry)) }}
                  </p>
                </ng-container>
              </div>
            </div>

              <p class="mt-3 text-sm text-[var(--app-text)]">
                {{ entry.description || 'Brak opisu' }}
              </p>

              <div class="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-[var(--app-text-muted)]">
                <span>
                  {{ entry.createdByUserName || 'Nieznany autor' }} ·
                  {{ entry.createdDate | date: 'dd.MM.yyyy, HH:mm' }}
                </span>

                <div class="flex items-center gap-2">
                  <p-badge
                    *ngIf="entry.editableByCurrentUser === false"
                    value="Tylko odczyt"
                    severity="secondary"
                  ></p-badge>
                  <p-badge
                    *ngIf="entry.editableByCurrentUser !== false"
                    value="Edytowalny"
                    severity="success"
                  ></p-badge>
                </div>
              </div>
            </button>
          </section>

          <section *ngIf="currentDayEntries().length > 0" class="space-y-3">
            <p class="text-xs font-semibold uppercase tracking-wide text-[var(--app-text-muted)]">
              Wpisy z tego dnia
            </p>

            <button
              *ngFor="let entry of currentDayEntries(); trackBy: trackByEntryId"
              type="button"
              class="w-full rounded-xl border p-4 text-left transition hover:border-[var(--app-primary)] hover:bg-[var(--app-surface)]"
              [style.border-color]="isSelectedEntry(entry) ? 'var(--app-primary)' : 'var(--app-border)'"
              [style.background-color]="isSelectedEntry(entry) ? 'color-mix(in srgb, var(--app-primary) 6%, transparent)' : 'var(--app-surface-solid)'"
              (click)="selectEntry(entry)"
            >
              <div class="flex items-start justify-between gap-3">
                <div class="min-w-0">
                  <p class="font-semibold text-[var(--app-text)] truncate">
                    {{ entry.workItemName || 'Bez nazwy' }}
                  </p>
                  <p class="text-xs text-[var(--app-text-muted)] truncate">
                    {{ entry.clientName || 'Bez klienta' }}
                  </p>
                </div>

              <div class="text-right">
                <p class="text-sm font-semibold text-[var(--app-text)]">
                  {{ entry.start | date: 'HH:mm' }} - {{ entry.end | date: 'HH:mm' }}
                </p>
                <p class="text-xs text-[var(--app-text-muted)]">
                  {{ formatDuration(entry.duration) }}
                </p>
                <ng-container *ngIf="resolveEntryEarnings(entry) != null">
                  <p class="mt-2 text-[10px] uppercase tracking-wide text-[var(--app-text-muted)]">
                    Wynagrodzenie
                  </p>
                  <p class="text-sm font-semibold text-[var(--app-primary)]">
                    {{ formatMoney(resolveEntryEarnings(entry)) }}
                  </p>
                </ng-container>
              </div>
            </div>

              <p class="mt-3 text-sm text-[var(--app-text)]">
                {{ entry.description || 'Brak opisu' }}
              </p>

              <div class="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-[var(--app-text-muted)]">
                <span>
                  {{ entry.createdByUserName || 'Nieznany autor' }} ·
                  {{ entry.createdDate | date: 'dd.MM.yyyy, HH:mm' }}
                </span>

                <div class="flex items-center gap-2">
                  <p-badge
                    *ngIf="entry.editableByCurrentUser === false"
                    value="Tylko odczyt"
                    severity="secondary"
                  ></p-badge>
                  <p-badge
                    *ngIf="entry.editableByCurrentUser !== false"
                    value="Edytowalny"
                    severity="success"
                  ></p-badge>
                </div>
              </div>
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>
</app-modal>

